import { render } from "./BaseModal.vue?vue&type=template&id=d97ffc76"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
script.render = render

export default script